export default "__VITE_ASSET__C6ZR0Ih2__"